import { render } from "./FBDisconnect.vue?vue&type=template&id=2e8d5d18&scoped=true"
import script from "./FBDisconnect.vue?vue&type=script&lang=ts"
export * from "./FBDisconnect.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-2e8d5d18"

export default script